<template lang='pug'>
  v-app(id="app")
    v-navigation-drawer(v-model='isDrawer', app, v-if="loggedIn", style="z-index:1000" dark, color="primary", width='240', mobile-break-point='960', disable-resize-watcher)
      template(v-slot:prepend)
        v-list-item(class='mt-6 ml-1')
          v-img(src="/logo.png", height='32', alt='Koos Workplace', contain, position='left')
      v-list(dense, v-model='item')
        v-list-item(@click="home", :key='0', :class='{"menu--ative": isSelectedMenu("/")}')
          v-list-item-icon
            svg(style="width:24px;height:24px", viewBox="0 0 24 24")
              path(fill="currentColor", d="M12,5A3.5,3.5 0 0,0 8.5,8.5A3.5,3.5 0 0,0 12,12A3.5,3.5 0 0,0 15.5,8.5A3.5,3.5 0 0,0 12,5M12,7A1.5,1.5 0 0,1 13.5,8.5A1.5,1.5 0 0,1 12,10A1.5,1.5 0 0,1 10.5,8.5A1.5,1.5 0 0,1 12,7M5.5,8A2.5,2.5 0 0,0 3,10.5C3,11.44 3.53,12.25 4.29,12.68C4.65,12.88 5.06,13 5.5,13C5.94,13 6.35,12.88 6.71,12.68C7.08,12.47 7.39,12.17 7.62,11.81C6.89,10.86 6.5,9.7 6.5,8.5C6.5,8.41 6.5,8.31 6.5,8.22C6.2,8.08 5.86,8 5.5,8M18.5,8C18.14,8 17.8,8.08 17.5,8.22C17.5,8.31 17.5,8.41 17.5,8.5C17.5,9.7 17.11,10.86 16.38,11.81C16.5,12 16.63,12.15 16.78,12.3C16.94,12.45 17.1,12.58 17.29,12.68C17.65,12.88 18.06,13 18.5,13C18.94,13 19.35,12.88 19.71,12.68C20.47,12.25 21,11.44 21,10.5A2.5,2.5 0 0,0 18.5,8M12,14C9.66,14 5,15.17 5,17.5V19H19V17.5C19,15.17 14.34,14 12,14M4.71,14.55C2.78,14.78 0,15.76 0,17.5V19H3V17.07C3,16.06 3.69,15.22 4.71,14.55M19.29,14.55C20.31,15.22 21,16.06 21,17.07V19H24V17.5C24,15.76 21.22,14.78 19.29,14.55M12,16C13.53,16 15.24,16.5 16.23,17H7.77C8.76,16.5 10.47,16 12,16Z")
          v-list-item-title
            v-row(class='ma-0', justify='space-between', align='center') ワークスペース
              v-badge(v-if='totalUsers', :content='totalUsers', inline, light, color='primaryDark3', class='pl-1')
        v-list-item(@click="edit", :key='1', :class='{"menu--ative": isSelectedMenu("/edit")}')
          v-list-item-icon
            svg(style="width:24px;height:24px", viewBox="0 0 24 24")
              path(fill="currentColor", d="M10 20H6V4H13V9H18V12.1L20 10.1V8L14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H10V20M20.2 13C20.3 13 20.5 13.1 20.6 13.2L21.9 14.5C22.1 14.7 22.1 15.1 21.9 15.3L20.9 16.3L18.8 14.2L19.8 13.2C19.9 13.1 20 13 20.2 13M20.2 16.9L14.1 23H12V20.9L18.1 14.8L20.2 16.9Z")
          v-list-item-title マイアクティビティ
        v-list-item(@click="projectTime", :key='2', v-if="$store.direct.getters.Login.hasLeadingProject", :class='{"menu--ative": isSelectedMenu("/projecttime")}')
          v-list-item-icon
            svg(style="width:24px;height:24px", viewBox="0 0 24 24")
              path(fill="currentColor", d="M14,12H15.5V14.82L17.94,16.23L17.19,17.53L14,15.69V12M4,2H18A2,2 0 0,1 20,4V10.1C21.24,11.36 22,13.09 22,15A7,7 0 0,1 15,22C13.09,22 11.36,21.24 10.1,20H4A2,2 0 0,1 2,18V4A2,2 0 0,1 4,2M4,15V18H8.67C8.24,17.09 8,16.07 8,15H4M4,8H10V5H4V8M18,8V5H12V8H18M4,13H8.29C8.63,11.85 9.26,10.82 10.1,10H4V13M15,10.15A4.85,4.85 0 0,0 10.15,15C10.15,17.68 12.32,19.85 15,19.85A4.85,4.85 0 0,0 19.85,15C19.85,12.32 17.68,10.15 15,10.15Z")
          v-list-item-title プロジェクト時間管理
        v-list-group(prepend-icon="domain", v-if="$store.getters['Login/isAdmin']", class='menu__management')
          template(v-slot:activator)
            v-list-item-content
              v-list-item-title 管理
          v-list-item(@click="users")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/users")}') ユーザー
          v-list-item(@click="exportTimesheet")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/export")}') エクスポート
          v-list-item(@click="calendar")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/calendar")}') カレンダー
          v-list-item(@click="membersActivity")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/membersactivity")}') メンバーアクティビティ
          v-list-item(@click="approveVacation")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/approvevacation")}') 休暇承認
          v-list-item(@click="informationBoard")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/information")}') 掲示板
          v-list-item(@click="memberTags")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/membertags")}') メンバータグ
          v-list-item(@click="privacyWord")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/privacyword")}') プライバシーワード
          v-list-item(@click="teamsIntegration")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/teams")}') Teams連携
          v-list-item(@click="clients")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/clients")}') クライアント
          v-list-item(@click="projects")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/projects")}') プロジェクト
          v-list-item(@click="projectAssigns")
            v-list-item-title(:class='{"menu__management--ative": isSelectedMenu("/assign")}') アサイン
      template(v-slot:append)
        v-col(class='pa-4')
          //- v-btn(rounded, light, block, color='white', class='blue--text font-weight-bold mb-3', v-if='', @click='openStatusMessage()') コメント
          v-btn(rounded, light, block, color='white', class='primaryDark1--text font-weight-bold', v-if='canStart', @click='startSession()', :disabled='inProcess') 開始
          v-btn(rounded, block, color='white', class='red--text font-weight-bold' v-if='canEnd', @click='endSession()', :disabled='inProcess') 終了
          v-btn(rounded, light, block, color='white', class='primary--text font-weight-bold mb-3', v-if='slackAuthorizeNeeded', @click='openSlackAuth()') Slack認証
        v-list(dense, v-model='item', class='bottom-item')
          v-list-group(prepend-icon='account_box')
            template(v-slot:activator)
              v-list-item-content
                v-list-item-subtitle ようこそ
                v-list-item-title {{displayName}}さん
            v-list-item(@click="mytags", :class='{"menu__management--ative": isSelectedMenu("/mytags")}')
              v-list-item-title パーソナルタグ
            v-list-item(@click="mypage", :class='{"menu__management--ative": isSelectedMenu("/mypage")}')
              v-list-item-title ユーザー情報
            v-list-item(@click="logout")
              v-list-item-title ログアウト
    v-content
      router-view(:key='$route.fullPath', @toggle='handleMenu', @show='handleUserCount')
    v-dialog(v-model='dialogSlackAuth', max-width='400')
      v-card
        v-card-title
        v-card-text Slackの認証をよろしくお願いします。OKを押すと、Slack認証画面に遷移します。一度権限を許可いただくと、その後は許可は必要ありません。
        v-card-actions
          v-btn(text, color='grey', @click='skipSlackAuth') 今後表示しない
          v-spacer
          v-btn(text, @click='dialogSlackAuth = false') キャンセル
          v-btn(text, @click='openSlackAuth') OK
    v-snackbar(:type="$store.direct.state.App.snackbarType", v-model="$store.direct.state.App.dispSnackbar", top, right, :color="$store.direct.state.App.snackbarType") {{ $store.direct.state.App.snackbarMessage }}
    v-overlay(:value="$store.direct.state.App.dispFullscreenLoading", absolute)
      v-row(class="d-flex flex-column align-center")
        v-progress-circular(indeterminate size="64")
        p {{$store.direct.state.App.loadingMessage}}
</template>

<script>
import Param from "@/lib/definition/variables";
import {Picker} from 'emoji-mart-vue'
import EmojiConvertor from 'emoji-js'
import basic from '@/components/mixins/basic'
import { msalInstance } from "@/lib/msal-config";

export default {
  mixins: [basic],
  name: 'App',
  components: {
    'emoji-picker': Picker
  },
  data: () => ({
    aaa: null,
    site: Param.Site,
    mini: true,
    item: 0,
    soundStart: null,
    soundEnd: null,
    audiosWeWantToUnlock: [],
    searching: false,
    dialogSlackAuth: false,
    isDrawer: null,
    totalUsers: null,
    inProcess: false
  }),
  computed: {
    isWWW: { get () {  
      var host = window.location.host
      if (host.includes('www.')) { return true }
      if (site.routerType === 'www') { return true }
      return false
    }},
    isAdmin: { get () { return this.$store.getters['Login/isAdmin'] }},
    loggedIn: { get () { return this.$store.getters["Login/loggedIn"] }},
    email: { get () { return this.$store.getters["Login/email"] }},
    slackAuthorizeNeeded: { get () { return this.$store.getters["Login/slackAuthorizeNeeded"] }},
    slackAuthorizedDialogShouldOpen: { get () { return this.$store.getters["Login/slackAuthorizedDialogShouldOpen"] }},
    logs: { get () { return this.$store.state.Users.logs }},
    displayName: { get () { return this.$store.getters["Login/displayName"] }},
    activeUsers() { return this.$store.state.Users.activeUsers },
    needToPlaySound() { return this.$store.state.Users.needToPlaySound },
    changeTypes() { return this.$store.state.Users.changeTypes },
    timesheets() { return this.$store.state.Timesheet.timesheets },
    canStart: { get() { 
      if (this.timesheets == null) return false
      var toReturn = true
      this.timesheets.forEach(ts => {
        if (ts.ended == null || ts.ended == '') {
          toReturn = false;
        }
      });
      return toReturn
    }},
    canEnd: { get() { 
      if (this.timesheets == null) return false
      if (this.timesheets.length == 0) return false
      var toReturn = false
      this.timesheets.forEach(ts => {
        if (ts.ended == null || ts.ended == '') {
          toReturn = true;
        }
      })
      return toReturn
    }},
    emojiList: { get() { return this.$store.state.Masters.emojiList }},

  },
  async mounted () {
    this.emojiConverter = new EmojiConvertor()
    this.emojiConverter.replace_mode = 'img'
    this.emojiConverter.allow_native = false
    this.emojiConverter.img_sets.apple.path = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple@5.0.1/img/apple/64/'
    try {
      const result = await msalInstance.handleRedirectPromise()
      if (result && result.idToken) {
        var host = window.location.host
        var tenantId = 'jtechs'
        var component = host.split('.')
        if (component.length > 0 && host.includes('koosapp.com')) {
          tenantId = component[0]
        }
        await this.$store.dispatch('Login/loginWithEntraToken', { tenantId, idToken: result.idToken })
        if (this.$store.getters['Login/loggedIn']) {
          this.$router.push(this.site.deployFolder + '/')
        }
      }
    } catch (error) {
      console.error('MSAL redirect handling error:', error)
      this.$store.commit('Login/SET_LOGIN_ERROR_MESSAGE', 'Entra IDログインに失敗しました。Koosに登録されたユーザーかご確認ください。')
      this.$router.push(this.site.deployFolder + '/loginview')
    }
    if (this.loggedIn) {
      this.search();
    }
    this.$nextTick(function () {
      window.setInterval(() => {
          if (this.loggedIn) {
            this.search();
          }
      },10000);
    })
    this.soundEnd = new Audio(this.site.deployFolder + '/sounds/sound1.mp3')
    this.soundStart = new Audio(this.site.deployFolder + '/sounds/sound2.mp3')
    this.soundComment = new Audio(this.site.deployFolder + '/sounds/sound4.mp3')
    this.soundReaction = new Audio(this.site.deployFolder + '/sounds/sound3.mp3')
    this.soundWeekly = new Audio(this.site.deployFolder + '/sounds/sound5weekly.mp3')
    this.soundError = new Audio(this.site.deployFolder + '/sounds/sound6error.mp3')
    this.soundApproval = new Audio(this.site.deployFolder + '/sounds/sound7approval.mp3')
    this.soundPicture = new Audio(this.site.deployFolder + '/sounds/sound8image.mp3')
    this.audiosWeWantToUnlock.push(this.soundEnd)
    this.audiosWeWantToUnlock.push(this.soundStart)
    this.audiosWeWantToUnlock.push(this.soundComment)
    this.audiosWeWantToUnlock.push(this.soundReaction)
    this.audiosWeWantToUnlock.push(this.soundWeekly)
    this.audiosWeWantToUnlock.push(this.soundError)
    this.audiosWeWantToUnlock.push(this.soundPicture)
    this.audiosWeWantToUnlock.push(this.soundApproval)
    document.body.addEventListener('click', this.unlock, false)
    document.body.addEventListener('touchstart', this.unlock, false)
    if (window.location.search.includes('oauth_success')) {
      this.dispSuccess('Slack認証を行いました。ご協力ありがとうございました。')
      window.history.replaceState({}, document.title, this.site.deployFolder +  "/");
     }
    if (window.location.search.includes('oauth_github_success')) {
      this.dispSuccess('Github認証を行いました。ご協力ありがとうございました。')
      window.history.replaceState({}, document.title, this.site.deployFolder +  "/");
     }  },
  methods: {
    getQueryStringParams: query => {
    return query
        ? (/^[?#]/.test(query) ? query.slice(1) : query)
            .split('&')
            .reduce((params, param) => {
                    let [key, value] = param.split('=');
                    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
                    return params;
                }, {}
            )
        : {}
    },
    async startSession() {
      if (this.inProcess) { return }
      try {
        this.inProcess = true
        await this.$store.dispatch("Timesheet/startSession", this.offsetMin);
        await this.search()
      } catch {
        this.dispError('開始に失敗しました。')
      }
      this.inProcess = false
    },
    async endSession() {
      if (this.inProcess) { return }
      try {
        this.inProcess = true
        await this.$store.dispatch("Timesheet/endSession", this.offsetMin);
        await this.search()
      } catch {
        this.dispError('開始に失敗しました。。')
      }
      this.inProcess = false
    },
    async search() {
      try {
        if (this.searching) { return }
        this.searching = true
        await this.$store.dispatch("Users/getRecurringWithReaction")
        if (this.needToPlaySound) {
          this.dispSuccess(this.$store.state.Users.lastHistory)
        }
        this.checkAndPlay();
        this.searching = false
        if (this.slackAuthorizedDialogShouldOpen) {
          this.dialogSlackAuth = true
          this.$store.dispatch("Login/openSlackAuthDialog")
        }
      } catch (e) {
        this.searching = false
        // eslint-disable-next-line no-console
        console.error(e)
      }
    },
    isSelectedMenu(menu) {
      return this.$route.path === menu ? true : false
    },
    logout() {
      this.$store.commit("Login/LOGOUT")
      this.$router.push(this.site.deployFolder + "/loginview")
    },
    home () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/")
    },
    users () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/users")
    },
    exportTimesheet () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/export")
    },
    calendar () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/calendar")
    },
    mytags () {
      this.$router.push(this.site.deployFolder + "/mytags")
    },
    mypage () {
      this.$router.push(this.site.deployFolder + "/mypage")
    },
    edit () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/edit")
    },
    projectTime () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/projecttime")
    },
    mySearch () {
      this.item = 1;
      this.$router.push(this.site.deployFolder + "/mysearch")
    },
    membersActivity () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/membersactivity")
    },
    memberTags () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/membertags")
    },
    privacyWord () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/privacyword")
    },
    teamsIntegration () {
      this.item = 0;
      this.$router.push(this.site.deployFolder + "/teams")
    },
    approveVacation () {
      this.$router.push(this.site.deployFolder + "/approvevacation")
    },
    informationBoard () {
      this.$router.push(this.site.deployFolder + "/information")
    },
    myActivity () {
      this.$router.push(this.site.deployFolder + "/")
    },
    openSlackAuth () {
      this.$store.dispatch("Login/openSlackAuth");
    },
    async skipSlackAuth () {
      this.dialogSlackAuth = false
      await this.$store.dispatch("Login/skipSlackAuth")
    },
    clients () {
      this.$router.push(this.site.deployFolder + "/clients")
    },
    projects () {
      this.$router.push(this.site.deployFolder + "/projects")
    },
    projectAssigns () {
      this.$router.push(this.site.deployFolder + "/assign")
    },
    openStatusMessage () {
      this.statusMessage = ''
      this.selectedEmoji = null
      this.emoji = null
      this.dialogStatusMessage = true
    },
    unlock () {
      if(this.audiosWeWantToUnlock) {
        for(let audio of this.audiosWeWantToUnlock) {
          audio.play()
          audio.pause()
          audio.currentTime = 0
        }
        this.audiosWeWantToUnlock = null
      }
    },
    checkAndPlay () {
      if (this.$store.state.Users.needToPlaySound) {
        if (this.changeTypes.includes('started') && this.$store.state.Home.loginSound) {
          this.soundStart.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundStart.play()
        } else if (this.changeTypes.includes('ended') && this.$store.state.Home.logoffSound) {
          this.soundEnd.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundEnd.play()
        } else if (this.changeTypes.includes('comment') && this.$store.state.Home.commentSound) {
          this.soundComment.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundComment.play()
        } else if (this.changeTypes.includes('reaction') && this.$store.state.Home.reactionSound) {
          this.soundReaction.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundReaction.play()
        } else if (this.changeTypes.includes('weekly') && this.$store.state.Home.weeklySound) {
          this.soundWeekly.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundWeekly.play()
        } else if (this.changeTypes.includes('picture') && this.$store.state.Home.pictureSound) {
          this.soundPicture.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundPicture.play()
        } else if (this.changeTypes.includes('vacation') && this.$store.state.Home.approvalSound) {
          this.soundApproval.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundApproval.play()
        } else if (this.changeTypes.includes('error') && this.$store.state.Home.errorSound) {
          this.soundError.volume = 0.1 * this.$store.state.Home.volume  / 50.0
          this.soundError.play()
        }
        this.$store.dispatch("Users/soundPlayed")
      }
    },
    handleMenu () {
      this.isDrawer = this.isDrawer ? false : true
    },
    handleUserCount(users){
      this.totalUsers = users
    }
  }
};
</script>

<style lang='scss'>
@import "@/scss/emoji.scss";
@import "@/scss/variables.scss";
@import "@/scss/overrides.scss";

.menu{
  &__management .v-list-group__items .v-list-item{
    padding-left: 3.435rem;
  }
}
.menu--ative .v-list-item__icon,
.menu--ative .v-list-item__title,
.v-list-item__title.menu__management--ative{
  font-weight: bold !important;
  color: white !important;
}
.bottom-item{
	margin-bottom: 4.2rem;
}
</style>
